export default "__VITE_ASSET__c6f1f040__"